/**
 * Бренд продукта для админки. Значения временные (до передачи клиенту) и
 * должны совпадать с `backend/src/common/brand.ts` и `mobile/brand.json`.
 * Заголовок вкладки задан отдельно — в `index.html` (корень admin/).
 */
export const BRAND = {
  name: 'Prava 24',
  /** URL-схема мобильного приложения для диплинков. */
  scheme: 'prava24',
  /** Публичный Telegram-канал (пример ссылки в баннере). */
  telegramChannelUrl: 'https://t.me/pravayhq',
} as const;
